export const REQUEST_WEBDASHBOARD_DATA = 'REQUEST_WEBDASHBOARD_DATA';
export const WEBDASHBOARD_DATA_RECEIVED = 'WEBDASHBOARD_DATA_RECEIVED';